import { call, put, select, takeEvery } from 'redux-saga/effects';
import { DeleteTargetedCatalogItem, targetedCatalogActionCreators, TargetedCatalogActionKeys } from '..';
import { IState } from '../..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { deleteItem } from '../targetedCatalogApi';
import { ITargetedCatalogGroup, ITargetedCatalogItem } from '../targetedCatalogInterfaces';

function* deleteTargetedCatalogItemSaga(action: DeleteTargetedCatalogItem) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<ITargetedCatalogItem[]> = yield call(deleteItem, action.payload.catalogItemId);
  const currentGroup: ITargetedCatalogGroup = yield select((state: IState) => {
    const item = state.targetedCatalog.items[action.payload.catalogItemId];
    return state.targetedCatalog.groups[item.preseasonCatalogItemGroupId];
  });

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else {
    yield put(targetedCatalogActionCreators.removeItem(action.payload.catalogItemId));

    if (response.value) {
      yield put(targetedCatalogActionCreators.setItemGroups([{ ...currentGroup, products: response.value }]));
    }
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteTargetedCatalogItem() {
  yield takeEvery(TargetedCatalogActionKeys.DELETE_TARGETED_CATALOG_ITEM, deleteTargetedCatalogItemSaga);
}
